import { createDefaultRoutes } from '@hatfieldmedia/hmcore'
import type { RouteRecordRaw } from 'vue-router'

// Routes are defined separately so they can be imported by vite.config.ts
// for sitemap generation without triggering router creation
export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    meta: {
      sitemap: { priority: 1.0 },
    },
  },
  // Add more routes with lazy loading for code splitting:
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import('@/views/AboutView.vue'),
  //   meta: {
  //     sitemap: { priority: 0.8, changefreq: 'monthly' },
  //   },
  // },
  // {
  //   path: '/admin',
  //   name: 'admin',
  //   component: () => import('@/views/AdminView.vue'),
  //   meta: {
  //     sitemap: { exclude: true }, // Exclude from sitemap
  //   },
  // },
]

// What vite.config.ts hands to the sitemap: the project's routes plus hmcore's
// own pages (accessibility, credit, copyright, privacy), which are prerendered
// and carry their own sitemap priorities. The 404 catch-all and the dev-only
// gallery are marked `sitemap: { exclude: true }` in hmcore and drop out here.
//
// This deliberately does not pass `redirectNotFoundToHome`: the catch-all is
// excluded either way, so the flag cannot change the sitemap. main.ts owns the
// routes the router actually runs, and reads the flag there.
export const sitemapRoutes: RouteRecordRaw[] = [...routes, ...createDefaultRoutes()]
